import { Box, LinearProgress, Paper, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { toFixed } from "src/services/utils";

export default function TopItem({ title, topData, classes, ...props }) {
  return (
    <Paper className={classes?.root} {...props}>
      <Typography color="textSecondary" style={{ fontSize: "14px", marginBottom: "0.5rem" }}>
        {title}
      </Typography>
      {topData.length > 0 ? (
        <>
          {topData.map((token, index) => {
            const percent = toFixed(token.percent * 100, 2);
            return (
              <Box
                key={index}
                width="100%"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                style={index > 0 ? { marginTop: "1rem" } : {}}
              >
                <Box width="50px">
                  <Typography>{token.symbol}</Typography>
                </Box>
                <Box width="calc(100% - 130px)">
                  <LinearProgress
                    style={{ borderRadius: "10px", height: "0.4rem" }}
                    variant="determinate"
                    value={percent}
                    classes={{ barColorPrimary: classes?.bar, colorPrimary: classes?.color }}
                  />
                </Box>
                <Box width="50px">
                  <Typography variant="subtitle2">{percent}%</Typography>
                </Box>
              </Box>
            );
          })}
        </>
      ) : (
        <>
          {[0, 0, 0].map((_, index) => (
            <Box
              key={index}
              width="100%"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              style={index > 0 ? { marginTop: "1rem" } : {}}
            >
              <Box width="50px">
                <Skeleton>
                  <Typography>BUSD</Typography>
                </Skeleton>
              </Box>
              <Box width="calc(100% - 130px)">
                <Skeleton width="100%">
                  <Typography>.</Typography>
                </Skeleton>
              </Box>
              <Box width="50px">
                <Skeleton>
                  <Typography>50%</Typography>
                </Skeleton>
              </Box>
            </Box>
          ))}
        </>
      )}
    </Paper>
  );
}
